require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

var $dJwbH$react = require("react");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

$parcel$export(module.exports, "composeRefs", function () {
  return $9c2aaba23466b352$export$43e446d32b3d21af;
});
$parcel$export(module.exports, "useComposedRefs", function () {
  return $9c2aaba23466b352$export$c7b2cbe3552a0d05;
});
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */

function $9c2aaba23466b352$var$setRef(ref, value) {
  if (typeof ref === 'function') ref(value);else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */


function $9c2aaba23466b352$export$43e446d32b3d21af() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    return refs.forEach(function (ref) {
      return $9c2aaba23466b352$var$setRef(ref, node);
    });
  };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */


function $9c2aaba23466b352$export$c7b2cbe3552a0d05() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return $dJwbH$react.useCallback($9c2aaba23466b352$export$43e446d32b3d21af.apply(void 0, refs), refs);
}